/**
 * CTA Section - Ready to Build
 * =============================
 * Call to action with video icon and benefits
 */

import React, { useState, useEffect, useRef } from 'react';
import { config } from '../../data/config';
import './CTA.css';

const CTA = () => {
  const sectionRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="cta-section" ref={sectionRef} id="cta">
      {/* Background */}
      <div className="cta-bg">
        <div className="cta-grid-bg" />
      </div>

      <div className="cta-container">
        <div className={`cta-card ${isInView ? 'in-view' : ''}`}>
          {/* Animated Border */}
          <div className="cta-border" />
          
          {/* Glow Effects */}
          <div className="cta-glow cta-glow-1" />
          <div className="cta-glow cta-glow-2" />

          {/* Content */}
          <div className="cta-content">
            {/* Video Icon */}
            <div className="cta-icon">
              <div className="cta-icon-ring" />
              <div className="cta-icon-inner">
                <i className="fas fa-video" />
              </div>
            </div>

            {/* Title */}
            <h2>
              {config.cta.title.split('Build')[0]}
              <span className="text-highlight">Build</span>?
            </h2>

            {/* Subtitle */}
            <p className="cta-subtitle">{config.cta.subtitle}</p>

            {/* Benefits */}
            <div className="cta-benefits">
              {config.cta.benefits.map((benefit, index) => (
                <div 
                  key={benefit} 
                  className="cta-benefit"
                  style={{ animationDelay: `${0.5 + index * 0.15}s` }}
                >
                  <i className="fas fa-check" />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            {/* CTA Button */}
            <a
              href={config.social.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
            >
              <i className="fab fa-whatsapp" />
              <span>{config.cta.buttonText}</span>
              <div className="btn-shine" />
            </a>
          </div>

          {/* Corner Decorations */}
          <div className="cta-corner cta-corner-tl" />
          <div className="cta-corner cta-corner-tr" />
          <div className="cta-corner cta-corner-bl" />
          <div className="cta-corner cta-corner-br" />
        </div>
      </div>
    </section>
  );
};

export default CTA;
